// extracted by mini-css-extract-plugin
export default {"gradient":"styles_gradient__6PlVG","banner":"styles_banner__o-Ggt","input":"styles_input__1tZBc"};